/**
 * Returns a new promise, and uses setTimeout to either resolve
 * or reject the promise after the amount of time set by the `time` param.
 * @category Utils
 */
export const wait = (time = 5000, shouldReject = false): Promise<void> =>
  new Promise((resolve, reject) => setTimeout(shouldReject ? reject : resolve, time))
